<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <template v-slot:activator="{ on }">
      <permission-button
          v-if="!canSendEmail"
          :permission="canSendEmail"
          :tooltip="{top: true, bottom: false, attach: false}"
          :noPermissionToolTip="'app.patient_has_invalid_email' | trans"
          color="primary"
      >
        {{ 'template.send_to_user' | trans }}
      </permission-button>
      <v-btn v-else color="primary" @click="open" :loading="sendingEmail">
        {{ 'template.send_to_user' | trans }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'template.send_to_user' | trans }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md no-padding>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                    disabled
                    v-model="patientEmail"
                    :label="'app.settings.email_settings.to_email' | trans"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    v-model="email.replayTo"
                    :label="'app.settings.email_settings.replay_to' | trans"
                    :rules="rules.replayTo"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    v-model="email.title"
                    :label="'app.settings.email_settings.title' | trans"
                    :rules="rules.title"
                />
              </v-flex>
              <v-flex xs12>
                <v-textarea
                    :label="'app.settings.email_settings.content' | trans"
                    :rules="rules.content"
                    v-model="email.content"
                    full
                    rows="10"
                    counter="10000"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 style="text-align: left">
                Ta wiadomość została wysłana z serwisu Dietico<br/>
                Odpowiedź prosimy kierować do {{ user.email }}
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-checkbox color="primary" style="flex: unset;" :label="'app.settings.email_settings.save_before_send' | trans" v-model="sendSettings"/>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn v-if="isAllowedToSendEmail" color="primary" @click="save()" :disabled="!valid" :loading="loading">
          {{ 'app.send' | trans }}
        </v-btn>
        <permission-button
            v-else
            :permission="false"
            :tooltip="{right: true, bottom: false, attach: false}"
        >
          {{ 'app.send' | trans }}
        </permission-button>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import RulesBuilder from "../../../utils/rulesBuilder";
import {trans} from "../../../app";
import {mapState} from "vuex";
import axios from "axios";

export default {
  name: "SendToUserModal",
  props: {
    sendingEmail: Boolean,
    isFormValid: Boolean,
  },
  data() {
    return {
      sendSettings: false,
      rulesBuilder: new RulesBuilder(),
      dialog: false,
      valid: true,
      loading: false,
      patientEmail: '',
      email: {
        title: '',
        content: '',
        replayTo: '',
      },
    };
  },
  methods: {
    open() {
      if (!this.isFormValid) {
        this.$emit('invalid-form');

        return;
      }
      this.email.title = this.$store.state.settings.email_settings.title || '';
      this.email.content = this.$store.state.settings.email_settings.content || '';
      this.patientEmail = this.menu.patient.email;
      this.email.replayTo = this.user.email;
      this.dialog = true;
      this.sendSettings = false;
    },
    close() {
      this.dialog = false;
    },
    saveSettings() {
      axios.put('/settings/email_settings', {title: this.email.title, content: this.email.content});
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.sendSettings) {
        this.saveSettings();
      }

      const data = {
        title: this.email.title,
        content: this.email.content,
        replay_to: this.email.replayTo,
      }

      this.$emit('send-email', data);
      this.close();
    },
  },
  computed: {
    ...mapState(['menu', 'user']),
    canSendEmail() {
      return Boolean(this.menu.patient.email && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.menu.patient.email));
    },
    isAllowedToSendEmail() {
      return ['administrator', 'dietitian_premium'].includes(this.user.role);
    },
    rules: function () {
      return {
        title: this.rulesBuilder
            .addRequiredRule(trans('app.settings.email_settings.title'))
            .addMaxLengthRule(trans('app.settings.email_settings.title'), 255)
            .getRules(),
        content: this.rulesBuilder
            .addRequiredRule(trans('app.settings.email_settings.content'))
            .addMaxLengthRule(trans('app.settings.email_settings.content'), 10000)
            .getRules(),
        email: this.rulesBuilder
            .addRequiredRule(trans('app.settings.email_settings.to_email'))
            .addMaxLengthRule(trans('app.settings.email_settings.to_email'), 10000)
            .addIsEmailRule(trans('app.settings.email_settings.to_email'))
            .getRules(),
        replayTo: this.rulesBuilder
            .addRequiredRule(trans('app.settings.email_settings.replay_to'))
            .addMaxLengthRule(trans('app.settings.email_settings.replay_to'), 10000)
            .addIsEmailRule(trans('app.settings.email_settings.replay_to'))
            .getRules(),
      };
    }
  },
}
</script>

<style scoped>

</style>
